export var DISABLED = -1;
export var BASE = 0;
export var HOVER = 1;
export var WARNING = 2;
export var ERROR = 3;
export var FOCUS = 4;
export var TOOLTIPHOVER = 98;
export var TOOLTIPICON = 99;
export var TOOLTIP = 100;
export var DIALOG = 101;
//# sourceMappingURL=index.js.map